import { render } from "./com_estudiantes.vue?vue&type=template&id=10e0ce4a&scoped=true"
import script from "./com_estudiantes.vue?vue&type=script&lang=js"
export * from "./com_estudiantes.vue?vue&type=script&lang=js"

import "./com_estudiantes.vue?vue&type=style&index=0&id=10e0ce4a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e0ce4a"]])

export default __exports__